module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADKSURBVHgB7dexDcIwFATQc0RDlxE8BLtQMgMbhA2yAg3TMERGoKPzJyBRBWzJ+dFF0b3aX8nJjnIGRESYApzc7s8TkPqA0P5ZMjQI3fGwv8JRAycB1mVe/i0arIcztwCjWFpgQAtnngEoFIBNAdgUgE0B2HYgm9uh6Dswt0Ot4QjF0oJch9reN8Dq9bUmO8Dq9bV+HaGIgiV6fS39yNgUgE0B2BSATQHYFIBNAdi2F2C8rDxQNrDnvqY3smTn3MDngSld2HMiIuvwAjysSzHZ89zHAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu2_click.png
// module id = rM5N
// module chunks = 1